import { Dialog } from "primereact/dialog"
import React from "react"
import Requests from "./RequestsManagement"

export default function Documents({ toggles, setToggles }) {
  return (
    <Dialog
      visible={toggles.documentsOpen}
      onHide={() => setToggles((prev) => ({ ...prev, documentsOpen: false }))}
      breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      style={{ width: "70vw" }}
      header="Documents"
    >
      <Requests />
    </Dialog>
  )
}
